import { StaticImageData } from 'next/image';
import { DeliveryTypeProduct, AvailableType } from '@entities/Delivery';

export enum StatusOrderFromStock {
  Free = 'бесплатно',
  TK = 'по тарифам ТК',
}

export interface ShopType {
  address: string;
  name: string;
  url: string;
  phone: string;
  sort?: number;
  distance?: number;
  quantityToday?: number;
  quantityNoToday?: number;
  statusDeliveryToday?: number;
  statusDeliveryNoToday?: number;
  shopId: number;
  type: DeliveryTypeProduct[];
  partner: number;
  timeWork: string;
  map: {
    x: number;
    y: number;
    zoom: number;
  };
  sticky?: boolean;
  isLiveQueue?: boolean;
}

export interface OrderFromStockType {
  title: string;
  status: StatusOrderFromStock;
  preview?: StaticImageData;
  quantity: number;
  time: number;
  shopId: number;
  address: string;
}

export interface DeliveryBlockType {
  title: string;
  mobileTitle: string;
  status?: StatusOrderFromStock;
  preview?: StaticImageData;
  time: string;
}

export interface availabilityType {
  quantity: number;
  type: AvailableType;
}

export interface ActionInitListShops {
  pickUpAllShops: ShopType[];
  delivery: number;
  orderFromStock: OrderFromStockType;
}

export interface AvailabilityProductSchema extends ActionInitListShops {
  pickUpToday: ShopType[];
  pickUpLater: ShopType[];
  overall: {
    availabilityNow: availabilityType;
    availabilityLater: availabilityType;
  };
  isLoaded: boolean;
  isLoadedDistance: boolean;
}

export interface ReturnFetchAvailabilityProductPromise {
  orderFromStock: OrderFromStockType;
  pickUpAllShops: ShopType[];
  overall: {
    availabilityNow: availabilityType;
    availabilityLater: availabilityType;
  };
  delivery: any;
}
